import React from 'react'
import { Field } from '@workwhile/ui'
import { ModalSelect } from 'components/ModalSelect'
import { useDocumentSignatureTemplatesQuery } from 'queries/company'

type CompanyFilePickerProps = {
  companyId?: number
  value?: number
  onChange: (value: number | undefined) => void
  error?: string
  enabled?: boolean
}

function fileLabel(path: string) {
  return path.split('/').pop() || path
}

export const CompanyFilePicker = ({
  companyId,
  value,
  onChange,
  error,
  enabled = true,
}: CompanyFilePickerProps) => {
  const { data, isPending, isError } = useDocumentSignatureTemplatesQuery(
    companyId ?? 0,
    { page: 0, pageSize: 100 },
    { enabled: Boolean(enabled && companyId) }
  )

  const fileOptions =
    data?.files.map((file) => ({
      label: `${fileLabel(file.path)} (${file.id})`,
      value: file.id,
    })) ?? []

  const placeholder = !companyId
    ? 'Select a company first'
    : isPending
      ? 'Loading files...'
      : isError
        ? 'Failed to load company files'
        : fileOptions.length === 0
          ? 'No company files found'
          : 'Select a signed form file'

  return (
    <Field label="Signed form file" error={error}>
      <ModalSelect
        options={fileOptions}
        value={fileOptions.find((option) => option.value === value) || null}
        onChange={(option) => onChange(option?.value ?? undefined)}
        placeholder={placeholder}
        isClearable
        isDisabled={!companyId || isPending || isError}
      />
    </Field>
  )
}
